import { MatPaginatorIntl } from "@angular/material/paginator";
import translateJson from '../../../translate.json'

export function ReportPaginator() {
    let i18 = translateJson.i18;
    const reportPaginatorIntl = new MatPaginatorIntl();
    reportPaginatorIntl.itemsPerPageLabel = i18.report.pagination.itemsPerPageLabel;
    reportPaginatorIntl.firstPageLabel = i18.report.pagination.firstPageLabel;
    reportPaginatorIntl.lastPageLabel = i18.report.pagination.lastPageLabel;
    reportPaginatorIntl.previousPageLabel = i18.report.pagination.previousPageLabel;
    reportPaginatorIntl.nextPageLabel = i18.report.pagination.nextPageLabel;
    let pageLabel = i18.report.pagination.pageLabel;
    let pageByLabel = i18.report.pagination.pageByLabel;
    
    reportPaginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
        return `${pageLabel} ${page + 1} ${pageByLabel} ${Math.ceil(length/pageSize)}`;
    }

    return reportPaginatorIntl;
}